<template>
    <div class="prp-table-container">
        <h1>{{data.desc_ures_pred}} - {{data.ures_pred}} </h1>

    <v-row>
        <v-col v-for='boleta in boletas' cols='12' md='12' >
            <DivisionDetalle
                v-bind:data=boleta
                v-bind:colores = colores
                v-bind:hexa_colors = hexa_colors
            ></DivisionDetalle>
        </v-col>
    </v-row>
    </div>
</template>

<script>

import ScaleLoader from 'vue-spinner/src/ScaleLoader';
import VueApexCharts from 'vue-apexcharts';
import DivisionDetalle from './DivisionDetalle';

export default {
    props: ['data'],
    components: {
        DivisionDetalle,
        ScaleLoader,
        apexchart: VueApexCharts,
    },

    data: () => ({
        loading:false,
        seriesparticipacion : [],
        seriesvotes:[],
        boletas:[],
        colores:'',
        hexa_colors:'',
        headers: [
            {
                text: 'Planilla Participante',
                align: 'start',
                sortable: false,
                value: 'name',
            },
            { text: 'Votos Ejercidos', value: 'total' },
        ],
        chartOptionsvotes: {
            chart: {
                width: 380,
                type: 'bar',
            },

            //colors : ['#2E93fA','#90BBD8'],
            //labels : ['Votantes','Faltantes'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
        chartOptionsparticipacion: {
            chart: {
                width: 380,
                type: 'pie',
            },
            //colors : ['#2E93fA','#90BBD8'],
            //labels : ['Votantes','Faltantes'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
    }),
    methods: {
        loadOptions: function() {
            this.boletas = this.data.boletas;
            this.colores = this.data.colores;
            this.hexa_colors = this.data.hexa_colors

        },
    },

    created() {
        this.loadOptions();
    },

}

</script>
